// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import StimulusReflex from "stimulus_reflex";

import consumer from "../channels/consumer";
import controller from "./application_controller";

const application = Application.start();
const context = require.context("controllers", true, /_controller\.js$/);
application.load(definitionsFromContext(context));

StimulusReflex.initialize(application, { consumer, controller, debug: true });

let cableDownTimeout;

function showCableStatus(connected) {
  if (connected) {
    clearTimeout(cableDownTimeout);
    document.body.classList.remove("cable-down");
  } else {
    cableDownTimeout = setTimeout(() => {
      document.body.classList.add("cable-down");
    }, 3000);
  }
}

window.addEventListener("stimulus-reflex:disconnected", () => {
  showCableStatus(false);
});
window.addEventListener("stimulus-reflex:connected", () => {
  showCableStatus(true);
});
